import { privateApiClient } from './apiClient';
import { hosts } from '../config/environment';

/**
 * URL publique (checkout) d'un terminal, pour le QR et le partage du lien.
 * @param {string} tag - Tag du terminal (ex. POS-ABC)
 * @returns {string}
 */
export const getPaymentTerminalPayUrl = (tag) => {
    if (!tag || !hosts.checkout) return '';
    return `${hosts.checkout}/payment-terminals/${tag}`;
};

/**
 * Service pour gérer les paiements POS
 */

/**
 * Initier un paiement et générer un QR code
 * @param {string} posId - ID du POS
 * @param {Object} data - Données du paiement { amount, currency, motive, ref, company }
 * @param {string|null} cashRegisterId - ID de la caisse (optionnel)
 * @returns {Promise<Object>} Réponse avec le contenu du paiement et QR code
 */
export const initiatePayment = async (posId, data, cashRegisterId = null) => {
    const url = cashRegisterId
        ? `/pos/payment/${posId}/initiate?cash=${cashRegisterId}`
        : `/pos/payment/${posId}/initiate`;
    
    const { data: response } = await privateApiClient.post(url, data);
    
    if (response.error) {
        throw new Error(response.message || 'Erreur lors de l\'initiation du paiement');
    }
    
    return response.contents;
};

/**
 * Valider et envoyer le paiement
 * @param {Object} paymentRqsModel - Modèle complet du paiement
 * @param {string|null} cashRegisterId - ID de la caisse (optionnel)
 * @returns {Promise<Object>} Réponse du paiement
 */
export const makePayment = async (paymentRqsModel, cashRegisterId = null) => {
    const url = cashRegisterId
        ? `/pos/payment/make?cash=${cashRegisterId}`
        : '/pos/payment/make';
    
    const { data: response } = await privateApiClient.post(url, paymentRqsModel);
    
    if (response.error) {
        throw new Error(response.message || 'Erreur lors de la validation du paiement');
    }
    
    return response;
};

/**
 * Récupérer la liste des providers de paiement
 * @param {Object} params - Paramètres de recherche { pge, lmt, slug, trg }
 * @returns {Promise<Array>} Liste des providers
 */
export const fetchPaymentProviders = async (params = {}) => {
    const defaultParams = {
        pge: 1,
        lmt: 100,
        slug: '',
        trg: 'payment',
        ...params
    };
    
    const { data: response } = await privateApiClient.get('/trs/providers', {
        params: defaultParams
    });
    
    return response.contents || [];
};

/**
 * Obtenir l'URL du QR code pour un POS
 * @param {string} posId - ID du POS
 * @returns {string} URL du QR code
 */
export const getPosQRCodeUrl = (posId) => {
    const apiUrl = process.env.REACT_APP_API_URL || '';
    // L'endpoint QR code est dans /exposed/v1, donc utiliser publicApiClient.baseURL
    return `${apiUrl}/exposed/v1/pos/qrcode/${posId}`;
};

